export let BitbucketScope = /*#__PURE__*/function (BitbucketScope) {
  BitbucketScope["BitbucketRepostitory"] = "bitbucket.repository";
  return BitbucketScope;
}({});
export const BITBUCKET_PRODUCT_ID = 'bitbucket';